export default __webpack_public_path__ + "static/media/gallery-wip-crystal-holder_05.bd4f72be.jpg";